import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { SharedModule } from '@shared';
import { MaterialModule } from '../../modules/material.module';


@Component({
    selector: 'app-app-selector',
    templateUrl: './app-selector.component.html',
    styleUrls: ['./app-selector.component.scss'],
    imports: [SharedModule, MaterialModule],
    encapsulation: ViewEncapsulation.None
})
export class AppSelectorComponent implements OnInit, OnDestroy {
  public constants = AppConstants;

  public subscription: Subscription = new Subscription();
  public hasReportAccess: boolean = localStorage.getItem(AppConstants.LABELS.hasReportsAccess) === 'YES';
  currentYear: number;
  constructor(private readonly router: Router) {this.currentYear = new Date().getFullYear(); }
  

  ngOnInit(): void {
    // this.eligibility.getClientDetails().subscribe((res) => console.log(res));
  }

  public navigateToReports(): void {
    this.router.navigate(['/main']);
  }

  public navigateToManagement(): void {
    this.router.navigate(['management/copay-schedule']);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }



}
